<template>
	<view class="box">
		<view class="cate">
			<view @click="changeRow(index)" :class="i === index ? 'cate-item active' : 'cate-item'" v-for="(item, index) in cate" :key="index">
				{{item.name}}
				<view class="cate-item-xiab" v-if="i === index"></view>
			</view>
		</view>
		<view class="list">
			<view class="list-item" v-for="(item, index) in 5" :key="index">
				<view class="a">
					<view class="a-left">
						<view class="a-left-tips">自提</view>
						<text>鼎元农机一号经销商</text>
					</view>
					<view class="a-right">待支付</view>
				</view>
				<view class="b">
					<view class="b-item">
						<view class="b-item-image">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="b-item-title">中联艾禾宽齿 适用雷沃/中联/久保田</view>
						<view class="b-item-jia">
							<text>¥499.00</text>
							<text>x1</text>
						</view>
					</view>
				</view>
				<view class="c">
					<view class="c-label">
						<view class="c-label-title">需付款：</view>
						<view class="c-label-price">
							<text>998</text>
							<text>.00</text>
						</view>
					</view>
					<view class="c-btns">
						<view class="c-btns-item">取消订单</view>
						<view class="c-btns-item blue">立即支付</view>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				i: '',
				cate: [
					{ name: '全部', id: '' },
					{ name: '待支付', id: 0 },
					{ name: '待发货/自提', id: 1 },
					{ name: '待收货', id: 2 },
				],
				list: []
			};
		},
		onLoad(options) {
			if (options.status) {
				this.i = Number(options.status)
			}
		},
		methods: {
			changeRow(index) {
				this.i = this.cate[index].id
			}
		}
	}
</script>
<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.list {
			width: 100%;
			padding: 22rpx 30rpx;
			box-sizing: border-box;
			.list-item {
				width: 100%;
				padding: 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 16rpx;
				margin-bottom: 20rpx;
				&:last-child {
					margin: 0 !important;
				}
				.a {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.a-left {
						display: flex;
						align-items: center;
						.a-left-tips {
							padding: 0 6rpx;
							height: 40rpx;
							line-height: 40rpx;
							background: #00B775;
							border-radius: 8rpx;
							font-weight: 400;
							font-size: 22rpx;
							color: #FFFFFF;
							margin-right: 16rpx;
						}
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #222222;
						}
					}
					.a-right {
						font-weight: 400;
						font-size: 26rpx;
						color: #E4001D;
					}
				}
				.b {
					width: 100%;
					height: 136rpx;
					display: flex;
					flex-direction: column;
					margin-top: 22rpx;
					.b-item {
						width: 100%;
						height: 136rpx;
						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						margin-bottom: 22rpx;
						&:last-child {
							margin: 0 !important;
						}
						.b-item-image {
							flex-shrink: 0;
							width: 136rpx;
							height: 136rpx;
							border-radius: 8rpx;
							overflow: hidden;
							border: 1rpx solid #E5E5E5;
							margin-right: 20rpx;
							image {
								width: 100%;
							}
						}
						.b-item-title {
							flex: 1;
							font-weight: 400;
							font-size: 30rpx;
							color: #222222;
							margin-right: 30rpx;
						}
						.b-item-jia {
							flex-shrink: 0;
							display: flex;
							flex-direction: column;
							align-items: flex-end;
							text {
								&:nth-child(1) {
									font-weight: 500;
									font-size: 30rpx;
									color: #222222;
								}
								&:nth-child(2) {
									font-weight: 400;
									font-size: 24rpx;
									color: #999999;
									margin-top: 14rpx;
								}
							}
						}
					}
				}
				.c {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-top: 24rpx;
					.c-label {
						display: flex;
						align-items: center;
						.c-label-title {
							font-weight: 400;
							font-size: 26rpx;
							color: #333333;
						}
						.c-label-price {
							display: flex;
							align-items: baseline;
							text {
								&:nth-child(1) {
									font-weight: 600;
									font-size: 32rpx;
									color: #222222;
									&::before {
										content: '￥';
										font-weight: 600;
										font-size: 26rpx;
										color: #222222;
									}
								}
								&:nth-child(2) {
									font-weight: 600;
									font-size: 26rpx;
									color: #222222;
								}
							}
						}
					}
					.c-btns {
						display: flex;
						align-items: center;
						.blue {
							border: 1rpx solid #004096;
							color: #004096 !important;
						}
						.c-btns-item {
							padding: 0 24rpx;
							box-sizing: border-box;
							height: 64rpx;
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: 34rpx;
							border: 1rpx solid #B2B2B2;
							font-weight: 400;
							font-size: 28rpx;
							color: #666666;
							margin-right: 20rpx;
							&:last-child {
								margin: 0 !important;
							}
						}
					}
				}
			}
		}
		.cate {
			width: 100%;
			height: 90rpx;
			display: flex;
			align-items: center;
			background: #FFFFFF;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 999;
			.cate-item {
				flex: 1;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: 30rpx;
				color: #666666;
				position: relative;
				.cate-item-xiab {
					position: absolute;
					bottom: 0;
					left: 50%;
					transform: translate(-50%, 0);
					width: 40rpx;
					height: 6rpx;
					background-color: #004096;
				}
			}
		}
	}
</style>